import React from 'react';

import NationalReportsListItem from '../../NationalReports/NationalReportsListItem';

class CountryProfileReportListItem extends NationalReportsListItem {
  render() {
    const attributes = this.props.data.attributes;

    return (
      <tr>
        <td>{ attributes.reportingYear}</td>
        <td>{ this.renderLinks() }</td>
      </tr>
    );
  }
}

export default CountryProfileReportListItem;



// WEBPACK FOOTER //
// ./src/components/CountryProfile/Menu/ItemReportListItem.js